import { createContext } from 'react';

type SetStateAction<T> = T | ((prev: T) => T);
type Dispatch<S> = (value: S) => void;

export const TabsContext = createContext<
    [number, Dispatch<SetStateAction<number>>] | null
>(null);
